export function composeRoles(...roleSets: (Set<string> | string[] | string)[]) {
  const composedRoles = new Set<string>();

  for (const roleSet of roleSets) {
    const roleSetArray =
      typeof roleSet === 'string'
        ? [roleSet]
        : Array.isArray(roleSet)
          ? roleSet
          : Array.from(roleSet.values());
    roleSetArray.forEach((role) => composedRoles.add(role));
  }

  return function (value: string[] | string) {
    const roles = Array.isArray(value) ? value : [value];
    return roles.some((role) => composedRoles.has(role));
  };
}
